import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useNav } from '../hooks/useNav';
import { useMusic } from '../hooks/useMusic';

const MusicController: React.FC = () => {
  const { currentSection } = useNav();
  const { playTrack, stopMusic, setVolume, volume } = useMusic();
  const lastSectionRef = useRef<string | null>(null);
  const isProcessingRef = useRef<boolean>(false);
  const [isMobile, setIsMobile] = useState(false);
  const prevVolumeRef = useRef<number>(0.5);

  // Детекция мобильных/планшетов (аналогично MobileTabletScreen)
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  // Mute/stop на мобильных/планшетах, восстановление на десктопе
  useEffect(() => {
    if (isMobile) {
      prevVolumeRef.current = volume;
      setVolume(0);
      stopMusic();
    } else {
      setVolume(prevVolumeRef.current || 0.5);
    }
  }, [isMobile, setVolume, stopMusic, volume]);
  
  // Определяем какой трек должен играть для текущего экрана
  const getTrackForSection = useCallback((section: string): string | null => {
    switch (section) {
      case 'screensaver':
      case 'intro_text':
      case 'intro_universe':
        return 'start';
      case 'briefing':
      case 'editor':
        return 'task';
      case 'end':
      case 'share':
        return 'final';
      default:
        return null;
    }
  }, []);
  
  useEffect(() => {
    const targetTrack = getTrackForSection(currentSection);
    
    console.log('🎵 MusicController: currentSection =', currentSection, 'targetTrack =', targetTrack, 'isProcessing =', isProcessingRef.current);
    
    if (isMobile) return;

    // Переключаем трек только если:
    // 1. Есть целевой трек
    // 2. Это новая секция (lastSectionRef.current !== currentSection)
    // 3. Не идет уже обработка
    if (targetTrack && lastSectionRef.current !== currentSection && !isProcessingRef.current) {
      console.log('🎵 Переключение музыки:', lastSectionRef.current, '->', currentSection, 'трек:', targetTrack);
      isProcessingRef.current = true;
      lastSectionRef.current = currentSection;
      
      // Запускаем трек через очередь
      playTrack(targetTrack as any).finally(() => {
        isProcessingRef.current = false;
      });
    }
  }, [currentSection, getTrackForSection, playTrack, isMobile]);
  
  // Компонент не рендерит ничего видимого
  return null;
};

export default MusicController;
